<template>
    <main class="custom-Wrapper-main AnonymousPage Wrapper-main Wrapper-centered">
        <div class="AnonymousPage-main Main Main-container">
            <section>
                <h1 class="custom-h1">Sorry!</h1>
                <h2 class="custom-h2">This website is private.</h2>
            </section>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'AnonymousPage'
    };
</script>
